// BjxySidebar.jsx — bjxy 自定义 sidebar (复制 vendor IndexSidebar, 改 newDiscussion.onclick 弹 BookingModal, 删 nav + navItems)
//   v0.2.0ebb16a0.c 新 (辉哥 2026-09-04 22:57 反馈): button 父链 1:1 跟 /all 一致
//     - 走 vendor IndexSidebar 模板 (渲染 <nav class="IndexPage-nav sideNav"><ul>...<button.IndexPage-newDiscussion></ul></nav>)
//     - 替换 newDiscussion.onclick 弹 BookingModal (代替 vendor 默认的 DiscussionComposer composer flow)
//     - 删除 items.add('nav', ...) 段 (vendor SelectDropdown 选单, bjxy 不用)
//     - 删除 navItems() 方法 (依赖 nav 段)
//     - 删除 canStartDiscussion 判断 (bjxy 没这概念, vendor 走 || 短路, 永远 disabled = true 错)
//     - 保留: className "Button Button--primary IndexPage-newDiscussion" + itemClassName "App-primaryControl" (跟 /all 1:1 DOM)
//     - 保留: listItems 包裹 (走 vendor 渲染, 走 vendor :has(> .App-primaryControl ~ .App-primaryControl) 触发 li 走 relative)
//     - 保留: vendor App.less @media @phone 段 (mobile button 视觉 51x46 半透明白日历)
//     - 改: icon "fas fa-edit" → "fas fa-calendar-plus" (语义: /all 是新建讨论, bjxy 是新建预约)
//     - 改: children 走 bjxy_hero_cta_text setting (跟 hero CTA button 一致) + fallback "预约体验"
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import listItems from 'flarum/common/helpers/listItems';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
import BookingModal from './BookingModal';
export default class BjxySidebar extends Component {
  view(vnode) {
    return m("nav", {
      className: classList('IndexPage-nav sideNav', this.attrs.className)
    }, m("ul", null, listItems(this.items().toArray())));
  }
  items() {
    const items = new ItemList();
    // v0.2.0ebb16a0.c 改: newDiscussion.onclick 弹 BookingModal, 删 nav (SelectDropdown)
    //   保留: vendor ItemList + Button 组件 + 1:1 跟 /all DOM 结构
    //   改: children 走 bjxy_hero_cta_text setting (跟 hero CTA button 一致) + fallback "预约体验"
    //   改: icon "fas fa-edit" → "fas fa-calendar-plus" (语义不同, bjxy 是预约不是讨论)
    //   改: onclick 弹 BookingModal (vendor 默认调 this.newDiscussionAction → app.composer.load DiscussionComposer + show)
    //   删: canStartDiscussion 判断 (vendor IndexSidebar L30 走 || 短路, bjxy 没这 attribute 永远 undefined falsy,
    //     走到 !app.session.user = false, canStartDiscussion = false, disabled = true 错) — bjxy 不读, 永远 disabled = false
    //   删: items.add('nav', ...) 段 + navItems() 方法 (vendor SelectDropdown + allDiscussions 链接, bjxy 不用)
    items.add('newDiscussion', m(Button, {
      icon: "fas fa-calendar-plus",
      className: "Button Button--primary IndexPage-newDiscussion",
      itemClassName: "App-primaryControl",
      "aria-label": app.forum.attribute('bjxy_hero_cta_text') || '预约体验',
      onclick: () => {
        // v0.2.0ebb16a0.c 改: 弹 BookingModal 代替 vendor DiscussionComposer
        //   跟 c.20 段 BjxyPage.jsx 渲染的 button onclick 一致
        app.modal.show(BookingModal);
      }
    }, app.forum.attribute('bjxy_hero_cta_text') || '预约体验'));
    return items;
  }
}
flarum.reg.add('ziiven-bjxy-website', 'forum/components/BjxySidebar', BjxySidebar);